var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$router.currentRoute.name!=404)?_c('NavTop'):_vm._e(),_c('router-view'),(_vm.$router.currentRoute.name!=404)?_c('NavNottom'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }